/**
 * Module icons in the brand line style (teal outline, green/orange fills).
 * Plan / Groceries / Recipes come from the brand card; Home and Pantry are
 * inline SVGs drawn to match until the designer supplies them.
 */
interface IconProps {
  className?: string;
}
const IMG = { 'aria-hidden': true, width: 28, height: 28 } as const;

export function PlanIcon({ className = 'size-7' }: IconProps) {
  return (
    <img
      src="/brand/icon-meal-plan-64.png"
      alt=""
      className={`object-contain ${className}`}
      {...IMG}
    />
  );
}
export function GroceriesIcon({ className = 'size-7' }: IconProps) {
  return (
    <img
      src="/brand/icon-grocery-list-64.png"
      alt=""
      className={`object-contain ${className}`}
      {...IMG}
    />
  );
}
export function RecipesIcon({ className = 'size-7' }: IconProps) {
  return (
    <img
      src="/brand/icon-recipes-64.png"
      alt=""
      className={`object-contain ${className}`}
      {...IMG}
    />
  );
}

export function HomeIcon({ className = 'size-7' }: IconProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <path
        d="M5 15 16 6l11 9v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"
        fill="#aecc5e"
        stroke="#1c5f53"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M13 28v-8h6v8"
        fill="#fe9e49"
        stroke="#1c5f53"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PantryIcon({ className = 'size-7' }: IconProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <rect
        x="6"
        y="4"
        width="20"
        height="24"
        rx="2"
        fill="#fdfdf7"
        stroke="#1c5f53"
        strokeWidth="2.5"
      />
      <path d="M6 12h20M6 20h20" stroke="#1c5f53" strokeWidth="2.5" />
      <rect
        x="9"
        y="6.5"
        width="5"
        height="4"
        rx="1"
        fill="#fe9e49"
        stroke="#1c5f53"
        strokeWidth="1.5"
      />
      <rect
        x="17"
        y="14.5"
        width="6"
        height="4"
        rx="1"
        fill="#aecc5e"
        stroke="#1c5f53"
        strokeWidth="1.5"
      />
      <rect
        x="10"
        y="22.5"
        width="4"
        height="4"
        rx="1"
        fill="#aecc5e"
        stroke="#1c5f53"
        strokeWidth="1.5"
      />
    </svg>
  );
}
